"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _isSupportedPropertyType = _interopRequireDefault(require("./isSupportedPropertyType"));

function _default(properties) {
  return properties.get('groups').map(function (group) {
    return {
      text: group.get('displayName'),
      options: group.get('properties').filter(_isSupportedPropertyType.default).map(function (property) {
        return {
          text: property.get('label'),
          value: property.get('name')
        };
      }).toArray()
    };
  }).toArray();
}

module.exports = exports.default;